import { useClipboard } from '@vueuse/core'
import { ElMessage } from 'element-plus'

export const copyToClipboard = async (
  text: string | null | undefined,
  options?: {
    successMessage?: string
    errorMessage?: string
    unsupportedMessage?: string
  }
) => {
  const { copy, isSupported } = useClipboard()

  const {
    successMessage = '已複製',
    errorMessage = '複製失敗',
    unsupportedMessage = '瀏覽器不支援剪貼簿'
  } = options || {}

  if (!text) {
    return
  }

  if (isSupported) {
    try {
      await copy(text)
      ElMessage({
        message: successMessage,
        type: 'success'
      })
    } catch (error) {
      console.error('Failed to copy the URL:', error)
      ElMessage({
        message: errorMessage,
        type: 'error'
      })
    }
  } else {
    ElMessage({
      message: unsupportedMessage,
      type: 'warning'
    })
  }
}
